<template>
  <div>
    <div class="container">
      <div class="row aboutus-outter">
        <div class="col-12 col-lg-4 align-self-center mb-3 mb-lg-0">
          <img src="/static/aboutus/1200/2.png" />
        </div>

        <div class="col-12 col-lg-8">
          <h2 class="text-danger topic-style text-center text-lg-left my-4 my-lg-0">久億光電科技有限公司</h2>
          <p style="font-size:16px;line-height:2.3" class="font-weight-bold text-left">
            &nbsp;&nbsp;&nbsp;&nbsp;久億光電科技有限公司前身為長億舞台照明有限公司(主要從事舞台燈光買賣)，創立於1980年,2003年於台中市三民西路成立長億特殊光源(LED專賣店)，2008年於台中市南屯區黎明路一段成立生產及組裝工廠並另行成立久億光電科技有限公司(主要生產LED)，並於2010年設立桃園分公司。2019年台中總公司遷址至台中市南屯區永春路42-80號(現址)膺續營運。
            <br />&nbsp;&nbsp;&nbsp;&nbsp;久億光電科技有限公司擁有300多坪廠辦，致力於LED研發以及應用推廣，同時透過「整合 、創新、品質」三大核心競爭優勢，積極提昇企業營運效能與產業競爭力，商品自行研發組裝、技術專業化、服務優質化，使得久億光電在中部地區已擁有相當高的評價，並於台中、桃園、台南設立經銷部門，提供全台銷售服務，成為LED產業市場之領導先驅。
          </p>
        </div>

        <div class="col-12">
          <img src="/static/aboutus/1216-01.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      a: [
        {
          xs: "/static/aboutus/320/1.jpg",
          sm: "/static/aboutus/320/1.jpg",
          md: "/static/aboutus/768/1.jpg",
          lg: "/static/aboutus/768/1.jpg",
          xl: "/static/aboutus/1200/1.jpg"
        }
      ],
      b: [
        { img: "/static/aboutus/320/1.jpg" },
        { img: "/static/news/320/1.jpg" },
        { img: "/static/aboutus/320/1.jpg" },
        { img: "/static/news/320/1.jpg" }
      ]
    };
  },
  methods: {
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    }
  },

  created: function() {
    this.pusha();
  }
};
</script>
<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"
.aboutus-outter
  @include media-breakpoint-up(xs) 
    padding-top: 55px
    padding-bottom: 55px
  @include media-breakpoint-up(sm)
    padding-bottom: 80px 
  @include media-breakpoint-up(md)
    padding-bottom: 55px

.topic-style
  @include media-breakpoint-up(xs) 
    font-size: 29px
    font-weight: 700
  @include media-breakpoint-up(sm)   
    font-size: 32px
    font-weight: 700
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue